import {createContext} from "react";

export const TokenContext = createContext({});
export const DistrictInsightContext = createContext()

